import {
  Card,
  Row,
  Col,
  Select,
  Input,
  Table,
  message,
  Button,
  Tooltip,
  Popconfirm,
} from "antd";
import { ColumnsType } from "antd/lib/table";
import { consultantVerify, getAllConsultantWithFilter } from "api/consultant";
import DescriptionText from "components/DescriptionText";
import IconCaretDown from "components/Icon/CaretDown";
import IconSearch from "components/Icon/Search";
import MainTitle from "components/MainTitle";
import { debounce } from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import PendingRequestAction from "./PendingRequestAction";
import { CheckOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import moment from "moment";

const PendingRequest = () => {
  const { t } = useTranslation("translation");
  const [visible, setvisible] = useState(false);
  const [selected, setselected] = useState();
  const [isAscending, setisAscending] = useState<string>("undefined");
  const [keyword, setkeyword] = useState<string>("");
  console.log(setselected);
  const { data, mutate } = useMutation(
    "get-all-pending-consultant",
    getAllConsultantWithFilter
  );

  const { mutate: verify } = useMutation(consultantVerify, {
    onSuccess: () => {
      handleVerified();
      message.success(`${t("SuccessfulVerify")}`);
    },
    onError: (err: any) => {
      message.error(err.response?.data.Errors.Message);
    },
  });

  const sendCode = (record: any) => {
    verify(record?.consultantId);
  };

  const PendingRequestColumns: ColumnsType<any> = [
    {
      key: "Consultancy Name",
      title: t("Consultancy_Name"),
      dataIndex: "name",
      render: (_, row) => {
        return (
          <Link
            to={`/pending-requests/${row?.consultantId}`}
            style={{ color: "#cc00ff" }}>
            {row?.name}
          </Link>
        );
      },
    },
    {
      key: "Email",
      title: t("Email_email"),
      dataIndex: "email",
      render: (_,row)=>{
        return(
          <a href={'mailto:' + row?.email}>{row?.email}</a>
        )
      },
    },
    {
      key: "Location",
      title: t("Location"),
      dataIndex: "location",
    },
    {
      key: "Phone ",
      title: t("Phone_phone"),
      dataIndex: "phone",
    },
    {
      key: "Created Date",
      title: t("Created_Date"),
      dataIndex: "createdAt",
      render: (text) => moment.utc(text).local().format("YYYY-MM-DD"),
    },
    {
      key: "Action",
      title: t("Action_action"),
      render: (record) => (
        <Tooltip title={`${t("Verify_Consultant")}`}>
          <Popconfirm
            title={`${t("ApproveConsult")}`}
            onConfirm={() => sendCode(record)}
            okText={`${t("Yes")}`}
            cancelText={`${t("No")}`}>
            <Button type="primary" icon={<CheckOutlined />} size={"large"} />
          </Popconfirm>
        </Tooltip>
        // <GhostBtn
        //   onClick={() => {
        //     setvisible(true);
        //     setselected(record);
        //   }}>
        //   <IconEdit />
        // </GhostBtn>
      ),
    },
  ];

  const handleVerified = () => {
    setvisible(false);
    mutate({
      isAscending: getAscendingValue(isAscending),
      keyword,
      pendings: true,
    });
  };

  const getAscendingValue = (value: string) => {
    if (value === "undefined") return undefined;
    if (value === "true") return true;
    if (value === "false") return false;
  };

  const onSearch = debounce((ev) => setkeyword(ev.target.value), 550);

  useEffect(() => {
    mutate({
      isAscending: getAscendingValue(isAscending),
      keyword,
      pendings: true,
    });
    // eslint-disable-next-line
  }, [isAscending, keyword]);

  useEffect(() => {
    mutate({ pendings: true });
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <MainTitle title={t("Consultant_Pending_Requests")} />
      <DescriptionText text={t("Approve_Pending_Request")} />
      <br />
      <br />
      <Card>
        <Row align="middle" gutter={12}>
          <Col>{t("Sort_by")}:</Col>
          <Col>
            <Select
              style={{ width: 120 }}
              defaultValue={isAscending}
              suffixIcon={<IconCaretDown />}
              onChange={(val: any) => setisAscending(val)}>
              <Select.Option value={"undefined"}>{t("Default")}</Select.Option>
              <Select.Option value={"true"}>{t("Ascending")}</Select.Option>
              <Select.Option value={"false"}>{t("Descending")}</Select.Option>
            </Select>
          </Col>
          <Col>
            <Input
              prefix={<IconSearch />}
              placeholder={t("search_search")}
              onChange={onSearch}
            />
          </Col>
        </Row>
        <br />
        <Table
          rowKey={(prop) => prop.id}
          pagination={{
            pageSize: 10,
          }}
          columns={PendingRequestColumns}
          dataSource={data || []}
          scroll={{ x: 1200 }}
        />
      </Card>
      <PendingRequestAction
        visible={visible}
        onCancel={() => setvisible(false)}
        selected={selected}
        handleVerified={handleVerified}
      />
    </>
  );
};

export default PendingRequest;
